export default {
  accessRuleList(state) {
    return state.accessRuleList;
  },
  geteditAccessrule(state) {
    return state.currentAccessObject;
  }
};
